import { create } from "zustand";
import { closeOtherModals, registerModalStore } from "./modal-registry";

/** Key this store is known by in the modal registry. */
const MODAL_NAME = "delete-account";

export const useDeleteAccountModalStore = create((set) => ({
  isModalOpen: false,
  openModal: () => {
    closeOtherModals(MODAL_NAME);

    set({ isModalOpen: true });
  },
  closeModal: () => set({ isModalOpen: false }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));

registerModalStore(MODAL_NAME, useDeleteAccountModalStore);
